interface Props {
  children: React.ReactNode;
}

export const GraphsContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className="py-5 grid md:gap-4 lg:gap-5 gap-3 lg:grid-cols-10 md:grid-cols-6 grid-cols-3 w-full">
      {children}
    </div>
  );
};
